import { SortingDirectionsE } from "../../../models/enums";

/**
 * If direction is desc adds _desc postfix to the sorting query param
 * */

export const getSortingTypeWithDirection = (sorting: string, direction: SortingDirectionsE): string => {
    return direction === SortingDirectionsE.ASC
        ? sorting
        : `${sorting}_${SortingDirectionsE.DESC}`
};